import { render, staticRenderFns } from "./printHKPurOrdersBatch.vue?vue&type=template&id=8c77559c&scoped=true&"
import script from "./printHKPurOrdersBatch.vue?vue&type=script&lang=js&"
export * from "./printHKPurOrdersBatch.vue?vue&type=script&lang=js&"
import style0 from "./printHKPurOrdersBatch.vue?vue&type=style&index=0&id=8c77559c&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c77559c",
  null
  
)

component.options.__file = "printHKPurOrdersBatch.vue"
export default component.exports